import React from "react";
import styled from "styled-components";
import InfoToolTip from "js/react/components/InfoToolTip";
import { Gap10, Gap5 } from "js/react/components/Gap";
import { Icon } from "@material-ui/core";
import { ToolTipBadge } from "../../Components/ToolTip";

export const SimpleLabelContainer = styled.label`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;
  font-weight: 600;
  margin: ${props => props.margin}px 0px;
  text-transform: uppercase;
    
    .popupmenu-icon {
        font-size: 16px;
    }
`;

export function SimpleLabel({ children, tooltip, margin = 10 }) {
    return (
        <SimpleLabelContainer margin={margin}>
            {children}
            {tooltip &&
                <>
                    <Gap10 />
                    <ToolTipBadge>{tooltip}</ToolTipBadge>
                </>
            }
        </SimpleLabelContainer>
    );
}

const WarningLabelContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: orangered;
    font-weight: 600;
    margin: 12px 0px;
`;

export function WarningLabel({ children, showIcon = true, tooltip }) {
    return (
        <WarningLabelContainer>
            {showIcon && <Icon>warning</Icon>}
            {showIcon && <Gap10 />}
            {children}
            {tooltip &&
                <>
                    <Gap10 />
                    <InfoToolTip title={tooltip} />
                </>
            }
        </WarningLabelContainer>
    );
}

